import React from 'react';
import { Brain } from 'lucide-react';
import { ProgressBar } from './ProgressBar';
import { StatSection } from './StatSection';

interface PersonalityStatsProps {
  personalityStats: {
    distribucionPersonalidad: Array<{ tipo: string; count: number }>;
  };
  totalConDatosComplementarios: number;
}

export const PersonalityStats: React.FC<PersonalityStatsProps> = ({
  personalityStats,
  totalConDatosComplementarios
}) => {
  const { distribucionPersonalidad } = personalityStats;

  // Colores para tipos de personalidad (basados en DISC)
  const getPersonalityColor = (tipo: string): string => {
    const lowerTipo = tipo.toLowerCase();
    if (lowerTipo.includes('domin')) return '#ef4444'; // Rojo - Dominante
    if (lowerTipo.includes('influy')) return '#fbbf24'; // Amarillo - Influyente
    if (lowerTipo.includes('establ')) return '#10b981'; // Verde - Estable
    if (lowerTipo.includes('cumplid')) return '#3b82f6'; // Azul - Cumplidor
    return '#8b5cf6';
  };

  if (distribucionPersonalidad.length === 0) {
    return null;
  }

  return (
    <StatSection title="Distribución por Tipo de Personalidad (DISC)" icon={Brain} iconColor="text-purple-600">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="space-y-3">
          {distribucionPersonalidad.map((pers, index) => (
            <ProgressBar
              key={index}
              label={pers.tipo}
              value={pers.count}
              total={totalConDatosComplementarios || 1}
              color={getPersonalityColor(pers.tipo)}
            />
          ))}
        </div>
        
        {/* Leyenda de colores DISC */}
        <div className="bg-gray-50 rounded-lg p-4">
          <h4 className="font-medium text-gray-700 mb-3">Tipos de Personalidad DISC</h4>
          <div className="space-y-2 text-xs">
            <div className="flex items-center">
              <div className="w-4 h-4 rounded-full mr-2" style={{ backgroundColor: '#ef4444' }}></div>
              <span className="text-gray-700"><strong>Dominante (D):</strong> Directo, decisivo, competitivo</span>
            </div>
            <div className="flex items-center">
              <div className="w-4 h-4 rounded-full mr-2" style={{ backgroundColor: '#fbbf24' }}></div>
              <span className="text-gray-700"><strong>Influyente (I):</strong> Entusiasta, sociable, persuasivo</span>
            </div>
            <div className="flex items-center">
              <div className="w-4 h-4 rounded-full mr-2" style={{ backgroundColor: '#10b981' }}></div>
              <span className="text-gray-700"><strong>Estable (S):</strong> Paciente, leal, cooperativo</span>
            </div>
            <div className="flex items-center">
              <div className="w-4 h-4 rounded-full mr-2" style={{ backgroundColor: '#3b82f6' }}></div>
              <span className="text-gray-700"><strong>Cumplidor (C):</strong> Preciso, analítico, organizado</span>
            </div>
          </div>
        </div>
      </div>
    </StatSection>
  );
};

export default PersonalityStats;
